<template>
	<pre v-html="$t('terms.legal_indication6')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication6',
};
</script>

<style scoped></style>
